import onGetAuditLogs from './onGetAuditLogs';
import onGetMoreAuditLogs from './onGetMoreAuditLogs';

export default {
  onGetAuditLogs,
  onGetMoreAuditLogs,
};
